export default "__VITE_ASSET__vR2YP2VQ__"